/**
 * Payment Slip Types Constants
 *
 * Defines all available payment slip types with their translation keys.
 */

export const PAYMENT_SLIP_TYPES = [
  {
    key: 'advancedPaymentOfProfitTax',
    labelKey: 'paymentSlipTypeAdvancedPaymentOfProfitTax',
  },
  {
    key: 'communalTax',
    labelKey: 'paymentSlipTypeCommunalTax',
  },
  {
    key: 'ecoTax',
    labelKey: 'paymentSlipTypeEcoTax',
  },
  {
    key: 'directorTax',
    labelKey: 'paymentSlipTypeDirectorTax',
  },
  {
    key: 'socialInsuranceForFoundersTax',
    labelKey: 'paymentSlipTypeSocialInsuranceForFoundersTax',
  },
];

/**
 * Get payment slip translation key by type key
 * @param {string} key - Payment slip type key
 * @returns {string} Translation key
 */
export const getPaymentSlipLabelKey = (key) => {
  const slip = PAYMENT_SLIP_TYPES.find((s) => s.key === key);
  return slip?.labelKey || key;
};
